// import helpers form user_data_personalizer 
import { removeNullCharacters } from '../../shared/utils/user_data_personaliser.js';

export function anonymize_claude_data(
    conversations,
    projects,
) {
    // for projects, keep the same json objec structure and remove the creator field 

    if (projects) {
        projects = projects.map(project => {
            let { creator, ...rest } = project;
            return rest;
        });
    }
    let anonymized_user_object = {
        conversations: removeNullCharacters(conversations), 
        projects: projects
    };

    return anonymized_user_object;
}
